import Grid from '@toast-ui/react-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default function DataPreviewGrid({
    rows = [],
    columns = [],
    height = 700,
    perPage = 5,
}) {
    return (
        <Grid
            data={rows}
            columns={columns}
            rowHeight={50}
            height={`${height}px`}
            width="100%"
            pagination={true}
            pageOptions={{
                useClient: true,
                perPage,
            }}
        />
    );
}
